import { render, staticRenderFns } from "./header-2.vue?vue&type=template&id=0187221b&scoped=true"
import script from "./header-2.vue?vue&type=script&lang=js"
export * from "./header-2.vue?vue&type=script&lang=js"
import style0 from "./header-2.vue?vue&type=style&index=0&id=0187221b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187221b",
  null
  
)

export default component.exports